import StatisticalCard from './StatisticalCard';

export default StatisticalCard;
